/**
 * Quality Management — the score ring shared by the per-call evaluation
 * panel and the agent dashboard's headline figure.
 *
 * Color encodes outcome, not decoration: red when the evaluation failed
 * outright, then green/blue/amber bands by score.
 */
import type { JSX } from 'react'

export function QmScoreRing({
  percentage,
  passed,
  size = 96,
}: {
  percentage: number
  passed: boolean | null
  /** px — the ring scales around its fixed viewBox. */
  size?: number
}): JSX.Element {
  const r = 34
  const c = 2 * Math.PI * r
  const color =
    passed === false ? '#dc2626' : percentage >= 85 ? '#16a34a' : percentage >= 60 ? '#2563eb' : '#f59e0b'
  return (
    <svg
      viewBox="0 0 84 84"
      className="flex-shrink-0"
      style={{ height: size, width: size }}
      aria-label={`Score ${Math.round(percentage)}%`}
    >
      <circle cx="42" cy="42" r={r} fill="none" stroke="#e5e7eb" strokeWidth="8" />
      <circle
        cx="42"
        cy="42"
        r={r}
        fill="none"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={c * (1 - Math.min(100, Math.max(0, percentage)) / 100)}
        transform="rotate(-90 42 42)"
      />
      <text x="42" y="46" textAnchor="middle" className="fill-slate-900 text-[17px] font-bold">
        {Math.round(percentage)}%
      </text>
    </svg>
  )
}
